/**
 * Analytics
 * Handlers for Analytics, like Google Analytics.
 */

/**
 * Calls global gtag fn to report conversion to Google Tags Manager
 * (eg. Register Interest / Calculator submission).
 */
export function gtag_report_conversion(action: string, label: string) {
  let send_to_adwords = 'AW-745747085/' + label
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', action, {
      send_to: [send_to_adwords, 'UA-139325418-1']
    })
  }
  return false
}
